import { useMemo } from 'react';
import { getClipTotalDurationInFrames } from '../../utils/configUtils';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { roundToNDecimalPlaces } from '@/player-config/src/utils/mathUtils';

export default function useRemotionPlayerDuration() {
  const { clipData, fps } = useClipsContext();

  const playerDuration = useMemo(() => {
    const totalDurationInFrames = getClipTotalDurationInFrames(clipData);
    return roundToNDecimalPlaces(totalDurationInFrames / fps, 3);
  }, [clipData, fps]);

  return playerDuration;
}
